import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, SxProps, Theme, Typography } from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import React from 'react';

import SurveillanceTableDisplay from '../../Surveillance/SurveillanceTable/SurveillanceTable';


type PanelProps = {
  panelSx: SxProps<Theme>;
  accordionSummarySx: SxProps<Theme>;
};

export const SurveillancePanel = ({ panelSx, accordionSummarySx }: PanelProps) => {
  return (
    <Stack spacing={1} className='panel panel-info' sx={panelSx}>
      <Accordion defaultExpanded disableGutters sx={{ boxShadow: 'none' }}>
        <AccordionSummary
          expandIcon={<GridExpandMoreIcon />}
          sx={accordionSummarySx}
        >
          <Typography sx={{ fontSize: '18px' }}>Surveillance</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ py: 2 }}>
          <Grid container spacing={1}>
            <SurveillanceTableDisplay />
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};
